import React from 'react'
import GetStarted from '../components/molecules/GetStarted'

const GetStartedPage = () => {
  return (
    <>
    <GetStarted/>
    </>
  )
}

export default GetStartedPage